import React, { useMemo, useState } from "react";
import { Div, Text } from "../../../Kit";
import { useLanguage } from "../../../../Store/modules/language";
import { Button } from "../../../Kit/Button";
import { UseFormRegister, UseFormReset } from "react-hook-form";
import { useDiscountCode } from "../../../../Store/modules/discountCode/discountCode";
import { useTheme } from "../../../../Store/modules/theme";

export type DiscountCodeProps = {
  register: UseFormRegister<any>;
  handleSubmit: () => void;
  type: string;
  reset: UseFormReset<any>;
  loading?: boolean;
  onRemoveDiscountCode?: () => void;
};
export const DiscountCode: React.FC<DiscountCodeProps> = (props) => {
  const { register, handleSubmit, type, reset, loading, onRemoveDiscountCode } = props;
  const [haveDiscountCode, setHaveDiscountCode] = useState(false);
  const { direction, locale } = useLanguage();
  const { discountCode, dispatchSetDiscountCode } = useDiscountCode();
  const { name: theme } = useTheme();
  const isCodeExist = useMemo(() => type === discountCode?.type, [discountCode?.type, type]);

  const toggleHaveDiscountCode = () => {
    setHaveDiscountCode(!haveDiscountCode);
  };

  return (
    <div>
      {!haveDiscountCode ? (
        <Text
          elementType="span"
          onClick={toggleHaveDiscountCode}
          fontWeight={400}
          className="text-sm "
          color="primary"
        >
          submitProcess.finalAnalysis.discountCode.haveDiscountCode
        </Text>
      ) : (
        <Div
          className="h-[41px] w-[265px] rounded-[4px] relative flex justify-start items-center"
          borderWidth="1px"
          borderColor="tertiary"
          borderStyle="solid"
        >
          <input
            {...register("discount_code")}
            type="text"
            className={`${theme === "dark" ? "text-white" : "text-dark"} border-0 outline-0 h-[39px] bg-[transparent] text-sm px-2 w-[calc(100%-93px)] ${!isCodeExist ? "bg-[transparent]" : theme === "light" ? "bg-[#F5F5F7]" : "bg-[#1F1F1F]"}`}
            dir={direction}
            disabled={isCodeExist}
          />
          <Button
            title={isCodeExist ? "delete" : "submitProcess.finalAnalysis.discountCode.verifyCode"}
            textColor="primary"
            bg="transparent"
            loading={loading}
            textClassName="text-xs"
            onClick={() => {
              if (isCodeExist) {
                onRemoveDiscountCode && onRemoveDiscountCode();
                dispatchSetDiscountCode(null);
                reset();
              } else {
                handleSubmit();
              }
            }}
            borderWidth="1px"
            borderColor="primary"
            borderStyle="solid"
            className={`w-[95px] h-[41px] absolute ${locale === "fa" ? "left-[-1px]" : "right-[-1px]"}`}
          />
        </Div>
      )}
    </div>
  );
};
